<div [class]="data().rootClasses" class="form-root" [style]="data().rootVars">
    <form style="pointer-events: none">
        <div class="form-fields-container">
            @for (control of data().elements; track $index) {
                @if (control.type !== formInputType.hidden) {
                    <div [class]="data().fieldClasses" class="form-field">
                        <!-- Dispatch on the element's type guard: `@switch (true)`
                             picks the first case whose guard passes. -->
                        @switch (true) {
                            @case (typeGuards.isInput(control)) {
                                <label> {{ control.label }}{{ control.required ? " *" : "" }} </label>

                                @if (!control.isDynamicPlaceholderEnabled) {
                                    <input
                                        [class]="data().fieldClasses"
                                        class="form-control"
                                        [attr.type]="control.htmlInputType"
                                        [attr.placeholder]="control.placeholder"
                                    />
                                }
                                @if (control.type === "phone" && control.isDynamicPlaceholderEnabled) {
                                    <ngx-intl-tel-input
                                        [cssClass]="'form-control ' + data().fieldClasses"
                                        [enableAutoCountrySelect]="true"
                                        [selectFirstCountry]="false"
                                        [separateDialCode]="true"
                                        [enablePlaceholder]="true"
                                        [searchCountryFlag]="true"
                                        [phoneValidation]="true"
                                        [searchCountryField]="[SearchCountryField.All]"
                                        [selectedCountryISO]="countryISO()"
                                        [numberFormat]="PhoneNumberFormat.International"
                                    />
                                }
                            }

                            @case (typeGuards.isTextarea(control)) {
                                <label> {{ control.label }}{{ control.required ? " *" : "" }} </label>
                                <textarea
                                    [class]="data().fieldClasses"
                                    class="form-control-textarea"
                                    [attr.placeholder]="control.placeholder"
                                ></textarea>
                            }

                            @case (typeGuards.isCheckbox(control)) {
                                <label class="sp-checkbox">
                                    <input [attr.type]="control.htmlInputType" />
                                    <span
                                        class="checkbox-text"
                                        [innerHTML]="
                                            ' ' + (control.label | removePTags) + (control.required ? ' *' : '')
                                        "
                                    ></span>
                                </label>
                            }

                            @case (typeGuards.isRadio(control)) {
                                <label> {{ control.label }}{{ control.required ? " *" : "" }} </label>
                                @for (option of control.options; track $index) {
                                    <div class="radio-options">
                                        <label>
                                            <input
                                                [attr.type]="control.htmlInputType"
                                                [value]="option.value"
                                                [checked]="option.selected"
                                            />
                                            <span class="radio-text"> {{ option.label }}</span>
                                        </label>
                                    </div>
                                }
                            }

                            @case (typeGuards.isSelect(control)) {
                                <label> {{ control.label }}{{ control.required ? " *" : "" }} </label>
                                <select [class]="data().fieldClasses" class="form-control">
                                    <option [ngValue]="null" selected disabled>
                                        {{ "select_value" | translate }}
                                    </option>
                                </select>
                            }
                        }
                    </div>
                }
            }

            @if (data().isShowCheckboxes) {
                @for (checkbox of data().checkboxes; track $index) {
                    <div [class]="data().fieldClasses" class="form-field">
                        <label class="sp-checkbox">
                            <input type="checkbox" />
                            <span
                                class="checkbox-text"
                                [innerHTML]="' ' + (checkbox.label | removePTags) + (checkbox.required ? ' *' : '')"
                            ></span>
                        </label>
                    </div>
                }
            }

            @if (courseTariffDetails()?.isPaid) {
                <span class="modal-divider"></span>

                <div class="sp-ui-text login-edu-price">
                    @if (course()?.name) {
                        <h4>{{ course().name }}</h4>
                    }
                    <p>
                        {{ courseTariffDetails()?.tariffName }} - {{ courseTariffDetails()?.price }}
                        {{ courseTariffDetails()?.currency }}
                    </p>
                </div>
            }

            <div class="form-button-wrapper login-edu-button-wrapper" [style]="data().wrapperVars">
                <a class="common-form-btn" [class]="data().buttonClasses" [style]="data().buttonVars">
                    {{ data().buttonLabel }}
                </a>
            </div>

            @if (showAuthorizationFormLink()) {
                <a class="login-edu-link">{{ "go_to_login" | translate }} &#8594; </a>
            }
        </div>
    </form>
</div>
